import React from 'react';

interface IconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const TaskExecutorsEdit = ({
    fill = '#1094F7',
    width = 13,
    height = 12,
}: IconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 13 12"
        fill="none"
    >
        <path
            d="M11.97 0.529298C11.63 0.189897 11.1693 -0.000732422 10.689 -0.000732422C10.2086 -0.000732422 9.7479 0.189897 9.40798 0.529298L0.5 9.43727V11.9993H3.06199L11.97 3.09129C12.3092 2.7513 12.4998 2.29061 12.4998 1.81029C12.4998 1.32998 12.3092 0.869285 11.97 0.529298ZM2.64999 10.9993H1.5V9.84927L8.15498 3.19929L9.30498 4.34929L2.64999 10.9993ZM11.263 2.38429L10.0095 3.63779L8.86198 2.48779L10.115 1.2363C10.2675 1.0838 10.4743 0.998124 10.69 0.998124C10.9056 0.998124 11.1125 1.0838 11.265 1.2363C11.4175 1.3888 11.5031 1.59563 11.5031 1.81129C11.5031 2.02696 11.4175 2.23379 11.265 2.38629L11.263 2.38429Z"
            fill={fill}
        />
    </svg>
);
